import React, { useState } from "react";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from "../../../../components/CustomTextInput";
import { ConstantService } from "../../../../services/ConstantService";
import { Helpers } from "../../../../helpers/Helpers";
import Box from "../../../../components/Box";
import { GetYurticiCargoByIdResponseYurticiCargoProduct } from "../../../../models/response/yurticiCargo/GetYurticiCargoByIdResponse";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { useDispatch } from "react-redux";

interface Props {
    productInformationRef: any
    yurticiCargoProducts: GetYurticiCargoByIdResponseYurticiCargoProduct[]
    setYurticiCargoProducts: React.Dispatch<React.SetStateAction<GetYurticiCargoByIdResponseYurticiCargoProduct[]>>
}

const OrderDetails = ({
    productInformationRef,
    setYurticiCargoProducts,
    yurticiCargoProducts
}: Props) => {
    const dispatch = useDispatch();
    const [yurticiCargoProductId, setYurticiCargoProductId] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);
    const [quantity, setQuantity] = useState<string | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [product, setProduct] = useState<string | undefined>(undefined);
    const [weight, setWeight] = useState<string | undefined>(undefined);
    const [desi, setDesi] = useState<string | undefined>(undefined);
    const [detailVolumetricWeight, setDetailVolumetricWeight] = useState<string | undefined>(undefined);

    const saveItem = () => {
        if (Helpers.isEmpty(yurticiCargoProductId)) {
            var o: GetYurticiCargoByIdResponseYurticiCargoProduct = {
                yurticiCargoProductId: Helpers.generateUUID(true),
                isSelected: false,
                detailVolumetricWeight: detailVolumetricWeight,
                potTypeId: selectedPotType?.value,
                potTypeName: selectedPotType?.label,
                product: product,
                quantity: quantity,
                weight: weight,
                desi: desi
            }

            setYurticiCargoProducts([...yurticiCargoProducts, o])
        }
        else {
            setYurticiCargoProducts(yurticiCargoProducts.map(function (x) {
                if (x.yurticiCargoProductId == yurticiCargoProductId) {
                    x.isSelected = false;
                    x.detailVolumetricWeight = detailVolumetricWeight;
                    x.potTypeId = selectedPotType?.value;
                    x.potTypeName = selectedPotType?.label;
                    x.product = product;
                    x.quantity = quantity;
                    x.weight = weight;
                    x.desi = desi;
                }

                return x;
            }))
        }

        setYurticiCargoProductId('');
        setQuantity('');
        setSelectedPotType(undefined);
        setProduct('');
        setWeight('');
        setDesi('');
        setDetailVolumetricWeight('');

        setIsOpen(false);
        scrollTo();
    }

    const setItemSelected = (_id: string) => {
        setYurticiCargoProducts(yurticiCargoProducts.map(function (x) {
            if (x.yurticiCargoProductId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setYurticiCargoProductId('');
        setQuantity('');
        setSelectedPotType(undefined);
        setProduct('');
        setWeight('');
        setDesi('');
        setDetailVolumetricWeight('');

        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = yurticiCargoProducts.filter(x => x.isSelected)[0];

        setYurticiCargoProductId(o.yurticiCargoProductId);

        setQuantity(o.quantity);
        setSelectedPotType(o.potTypeId && o.potTypeName ? { label: o.potTypeName, value: o.potTypeId } : undefined);
        setProduct(o.product);
        setWeight(o.weight);
        setDesi(o.desi);
        setDetailVolumetricWeight(o.detailVolumetricWeight);

        setIsOpen(true);
        scrollTo();
    }

    const deleteItems = async () => {
        setYurticiCargoProducts(yurticiCargoProducts.filter(x => !x.isSelected));
    }

    // Dip toplam (07.10.2026): Ağırlık, Desi, Detay Hacimsel Ağırlık.
    const toplam = (alan: 'weight' | 'desi' | 'detailVolumetricWeight') =>
        Helpers.correctPrice(Helpers.sumOfNumbers(yurticiCargoProducts.map(x => Helpers.toNumber(x[alan]))), 2);

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = productInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const selectAll = () => {
        var isAllSelected = yurticiCargoProducts.length == yurticiCargoProducts.filter(x => x.isSelected).length;

        setYurticiCargoProducts(yurticiCargoProducts.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' ref={productInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Sipariş Detayları</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Adet" isLabelRequired value={quantity} setValue={setQuantity} />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Kap Cinsi"
                                            isLabelRequired
                                            selectedValue={selectedPotType}
                                            onChange={setSelectedPotType}
                                            // insertable={{
                                            //     onSubmit: { code: 'POT_TYPE' }
                                            // }}
                                            onMenuOpen={() => ConstantService.getConstantList('POT_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomTextInput labelText="Ürün" isLabelRequired value={product} setValue={setProduct} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Ağırlık" isLabelRequired value={weight}
                                            setValue={(val: string) => {
                                                setWeight(val);

                                                if (Helpers.isEmpty(val))
                                                    setDetailVolumetricWeight(desi ?? '');
                                                if (Helpers.isEmpty(desi))
                                                    setDetailVolumetricWeight(val ?? '');
                                                else {
                                                    var v1 = Helpers.toNumber(val);
                                                    var v2 = Helpers.toNumber(desi);

                                                    setDetailVolumetricWeight(v1 > v2 ? val : desi);
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Desi" isLabelRequired value={desi}
                                            setValue={(val: string) => {
                                                setDesi(val);

                                                if (Helpers.isEmpty(val))
                                                    setDetailVolumetricWeight(weight ?? '');
                                                if (Helpers.isEmpty(weight))
                                                    setDetailVolumetricWeight(val ?? '');
                                                else {
                                                    var v1 = Helpers.toNumber(val);
                                                    var v2 = Helpers.toNumber(weight);

                                                    setDetailVolumetricWeight(v1 > v2 ? val : weight);
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Detay Hacimsel Ağırlık" isLabelRequired value={detailVolumetricWeight} setValue={setDetailVolumetricWeight} isDisabled />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    {/* <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={"1"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={yurticiCargoProducts.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={yurticiCargoProducts.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={yurticiCargoProducts.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={yurticiCargoProducts.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box> */}

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            {/* <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={yurticiCargoProducts.filter(x => x.isSelected).length > 0 && yurticiCargoProducts.filter(x => x.isSelected).length == yurticiCargoProducts.length} />
                                                    </label>
                                                </div>
                                            </th> */}
                                            <th>Adet</th>
                                            <th>Kap Cinsi</th>
                                            <th>Ürün</th>
                                            <th>Ağırlık</th>
                                            <th>Desi</th>
                                            <th>Detay Hacimsel Ağırlık</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            yurticiCargoProducts.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            yurticiCargoProducts.map((item, index) =>
                                                <tr>
                                                    {/* <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.yurticiCargoProductId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td> */}
                                                    <td>{item.quantity}</td>
                                                    <td>{item.potTypeName}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.weight}</td>
                                                    <td>{item.desi}</td>
                                                    <td>{item.detailVolumetricWeight}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        yurticiCargoProducts.length > 0 && (
                                            <tfoot>
                                                <tr className="ebbe-dip-toplam">
                                                    <td>Toplam</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{toplam('weight')}</td>
                                                    <td>{toplam('desi')}</td>
                                                    <td>{toplam('detailVolumetricWeight')}</td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default OrderDetails;